import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { LegalBrandLink, LegalContactEmail } from "./LegalTenantBits";

// Fallback netral. Komponen client (LegalContactEmail) memakai
// useTenant().support_email bila tenant menyetelnya; konstanta ini tetap
// diekspor karena halaman legal (server components) meng-import-nya langsung.
export const CONTACT_EMAIL = "support@growclass.id";
const FOOTER_LINKS: {
  label: string;
  href: string;
}[] = [{
  label: "Pusat Bantuan",
  href: "/help"
}, {
  label: "FAQ",
  href: "/faq"
}, {
  label: "Mulai Cepat",
  href: "/getting-started"
}, {
  label: "Kebijakan Privasi",
  href: "/privacy"
}, {
  label: "Kebijakan Cookie",
  href: "/cookies"
}, {
  label: "Syarat & Ketentuan",
  href: "/terms"
}, {
  label: "Kebijakan Refund",
  href: "/refund"
}, {
  label: "Ketentuan Affiliate",
  href: "/affiliate-terms"
}];

/** Judul bagian + isi, dipakai di seluruh halaman legal/bantuan. */
export function Section(t0) {
  const $ = _c(7);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="text-lg font-bold text-warm-black mb-3">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="space-y-3 text-[15px] leading-relaxed text-gray-700">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <section className="mt-8">{t1}{t2}</section>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** List bullet konsisten. */
export function Bullets(t0) {
  const $ = _c(4);
  const {
    items
  } = t0;
  let t1;
  if ($[0] !== items) {
    t1 = items.map(_temp);
    $[0] = items;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <ul className="list-disc space-y-1.5 pl-5 marker:text-primary">{t1}</ul>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

/** Shell halaman publik (legal & bantuan) — header logo, konten, footer cross-link. */
function _temp(it, i) {
  return <li key={i}>{it}</li>;
}
export function LegalPage(t0) {
  const $ = _c(20);
  const {
    title,
    subtitle,
    updatedAt,
    draft: t1,
    children
  } = t0;
  const draft = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <header className="border-b border-black/[0.06] bg-white/70 backdrop-blur sticky top-0 z-10"><div className="mx-auto flex h-16 max-w-3xl items-center justify-between px-5"><LegalBrandLink /><Link href="/dashboard" className="text-sm font-medium text-gray-600 transition-colors hover:text-primary">Ke Dashboard</Link></div></header>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== draft) {
    t3 = draft && <span className="mb-4 inline-flex items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-700">Sedang disusun</span>;
    $[1] = draft;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== title) {
    t4 = <h1 className="text-3xl font-bold tracking-tight text-warm-black">{title}</h1>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== subtitle) {
    t5 = subtitle && <p className="mt-2 text-[15px] leading-relaxed text-gray-600">{subtitle}</p>;
    $[5] = subtitle;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== updatedAt) {
    t6 = updatedAt && <p className="mt-3 text-xs text-gray-500">Terakhir diperbarui: {updatedAt}</p>;
    $[7] = updatedAt;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== children) {
    t7 = <div className="mt-2">{children}</div>;
    $[9] = children;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="mb-3 text-sm font-semibold text-warm-black">Halaman lain</p>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex flex-wrap gap-x-4 gap-y-2">{FOOTER_LINKS.map(_temp2)}</div>;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <footer className="mt-14 border-t border-black/[0.08] pt-8">{t8}{t9}<p className="mt-6 text-xs text-gray-500">Butuh bantuan? Hubungi kami di <LegalContactEmail fallback={CONTACT_EMAIL} />.</p></footer>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
    t11 = <div className="min-h-screen bg-warm-cream">{t2}<main id="main-content" tabIndex={-1} className="mx-auto max-w-3xl px-5 py-10">{t3}{t4}{t5}{t6}{t7}{t10}</main></div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}
function _temp2(l) {
  return <Link key={l.href} href={l.href} className="text-sm text-gray-600 transition-colors hover:text-primary">{l.label}</Link>;
}